import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import { useDeferredValue } from "react";

export default function List({ images, handleOpen }) {
  const deferredImages = useDeferredValue(images);

  return (
    <div className={classes.row}>
      <ul className={`${classes.list}`}>
        {deferredImages.slice(0, 6).map(({ images: { webp, png } }, index) => (
          <li
            onClick={() => handleOpen(images, index)}
            className={classes.list__item}
            key={uuid()}
          >
            <div className={classes.image}>
              <picture>
                <source srcSet={webp} type="image/webp" />
                <img src={png} alt="history" width={331} height={214} />
              </picture>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
